import { forwardRef } from 'react'
import styled from 'styled-components'

import theme from '~/shared/styles/theme'

// TODO icon 위치

interface Props {
  options?: {
    value: string
    label: string
  }[]
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value?: string
}

const Dropdown = forwardRef(
  (
    { options, onChange, value, ...rest }: Props,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <Wrapper ref={ref}>
        <select onChange={onChange} size={1} value={value} {...rest}>
          {options
            ?.slice()
            ?.reverse()
            .map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      </Wrapper>
    )
  },
)

export default Dropdown

const Wrapper = styled.div`
  > select {
    cursor: pointer;

    position: relative;

    display: flex;
    align-items: center;
    justify-content: space-between;

    box-sizing: border-box;
    min-width: fit-content;
    height: 49px;
    padding: 12px 20px;

    font-family: NanumSquareNeo-Regular, sans-serif;

    background-color: ${theme.colors.grey_1};
    border: none;
    border-radius: 12px;
  }
`
